const clazzPrefix = "ExecutionState$";

export interface ExecutionState {
  clazz: "ExecutionState$Running" | "ExecutionState$Completed" | "ExecutionState$Deleting";
}

export function isCompletedExecutionState(executionState?: ExecutionState) {
  return executionState && completedExecutionStates[executionState.clazz];
}

const completedExecutionStates = {
  ExecutionState$Running: false,
  ExecutionState$Completed: true,
  ExecutionState$Deleting: true,
};
